<template>
    <Benchmark />
</template>

<script>
import Benchmark from './components/Benchmark.vue';
    export default {
        components: {
            Benchmark
        }
    }
</script>

<style lang="scss">
@import "../styles/benchmark/benchmark.scss";

[v-cloak] {
    display: none
}
</style>
